// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn[data-v-3b9a83a6]{border-radius:0;color:var(--light-color)}.dropdown-toggle[data-v-3b9a83a6]{padding:0}.dropdown-toggle[data-v-3b9a83a6]:after{display:none}.collapsible[data-v-3b9a83a6]{max-height:0;transition:max-height .25s ease-out;overflow:hidden}.collapsible.expanded[data-v-3b9a83a6]{max-height:700px}", ""]);
// Exports
module.exports = exports;
